<template>
  <div v-if="functionArguments[functionName]" class="formula_tooltip-container" :style="{ transform }">
    <div class="formula_tooltip">
      {{ functionName }}(<span v-html="functionArgument"></span
      ><span v-if="functionArguments[functionName].repeated"> ...</span>)
    </div>
  </div>
</template>

<script>
import DesignerMixin from "../DesignerMixin";
import { functionArguments } from "./FormulaConstants";
export default {
  mixins: [DesignerMixin],
  props: ["functionName", "argNumber", "totalArg"],
  data() {
    return {
      functionArguments,
      transform: "unset",
    };
  },
  computed: {
    functionArgument() {
      let requiredArgs = functionArguments[this.functionName].required;
      let repeatedArgs = functionArguments[this.functionName].repeated;

      let argsToShow = [...requiredArgs];
      let temp = 2;
      while (repeatedArgs && (this.argNumber > argsToShow.length - 2 || argsToShow.length - 2 < this.totalArg)) {
        for (let i = 0; i < repeatedArgs.length; i++) {
          const text = repeatedArgs[i] + "" + temp;
          const startText = i === 0 ? " [" + text : text;
          const endText = i === repeatedArgs.length - 1 ? "]" : "";
          argsToShow.push(startText + endText);
        }
        temp++;
      }
      if (this.argNumber < argsToShow.length) argsToShow[this.argNumber] = "<b>" + argsToShow[this.argNumber] + "</b>";
      return argsToShow.join(", ");
    },
  },
  watch: {
    totalArg(newValue, oldValue) {
      this.setTransform();
    },
  },
  mounted() {
    this.setTransform();
  },
  methods: {
    setTransform() {
      const editCellBound = document.querySelector(".kk-editcell")?.getBoundingClientRect();
      const elBound = document.querySelector(".formula_tooltip-container")?.getBoundingClientRect();
      if (!elBound || !editCellBound) return;

      const translateX = editCellBound.left + elBound.width + 50 > window.innerWidth ? "-100%" : "0";
      const translateY = editCellBound.top + elBound.height + 50 > window.innerHeight ? "-100%" : "0";
      this.transform = `translate(${translateX},${translateY})`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/styles/variables.less";

.formula_tooltip {
  &-container {
    width: max-content;
    max-width: 700px;
    padding: 0 0.3rem;
    text-align: center;
    border: 0.5px solid @kk-color-gray;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    background-color: white;
    color: black;
    position: absolute;
    top: 110%;
    z-index: 1000;
  }
}
</style>
